// extracted by mini-css-extract-plugin
module.exports = {"light":"App_light__2ac_u","dark":"App_dark__22_2O"};